// Packages and components
import React from 'react';
import { StyledTab } from './SHDTab.styles';

// Types
import type { SHDTabProps } from './SHDTab.d';

const SHDTab: React.FC<SHDTabProps> = ({ className = 'tab', title }) => {
  return <StyledTab data-testid="tab" className={className} title={title} />;
};

export default SHDTab;
